export default __webpack_public_path__ + "assets/fe760d1e7af0969c6a4faf895ecb0fd0.png";